export const HEADERS = {
    chaCode: "CHA Code",
    chaName: "CHA Name",
    createdByName: "Created By",
    createdOn: "Created On",
    updatedByName: "Modified By",
    updatedOn: "Modified On",
    edit: "Edit / Delete",
}
